import React, { ChangeEvent } from 'react';
import { Box, Modal, Grid, Zoom, Checkbox, FormControlLabel, Container, TextField } from '@mui/material';
import { BackdropLoading } from '../../../shared/spinner/backdropLoading';
import { useDelayedEffect } from '../../../shared/delayedEffect/useDelayedEffect';
import { CancelButton, CheckBoxContainer, ModalLabel, modalStyle, OkButton, TextFieldForm, TextFieldLabel } from './shusshinkoCondition.styles';
import { sessionDisconnectedCheck } from '../../../shared/api/sessionDisconnectedCheck';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SearchCrudApiRequest } from '../../../shared/model/apiRequestModel';
import crud from '../../../shared/api/crud';
import { useNavigate } from 'react-router-dom';
import { SystemErrorMsg, SystemErrorTitle } from '../../../constants';
import { ShussinkoCheckBoxContainer } from './checkBoxCompornent';

interface OwnProps {
    isOpen: boolean,
    handleClose: (isOpen: boolean) => void
    handleOk: (value: DialogItemType[], operator: string) => void,
}

interface DialogItemType {
    id: string
    value: string
}

interface CodeList {
    id: string
    value: string
}

interface Item {
    id: string
    value: string
}

const screenId = "U043"

const ShusshinkoDialog = (props: OwnProps) => {
    const navigate = useNavigate();
    const { isOpen, handleClose } = props
    const [open, setOpen] = React.useState(isOpen);
    const [codeList, setCodeList] = React.useState<CodeList[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [items, setItems] = React.useState<Item[]>([])
    const [error, setError] = React.useState(false)
    const [keyword, setKeyword] = React.useState('')

    //チェック状態管理
    const [checkCode, setCheckCode] = React.useState<Set<string>>(new Set());
    //キーワード検索状態管理
    const [searchHidden, setSearchHidden] = React.useState<Set<string>>(new Set());

    const getShusshinkoMaster = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getShusshinkoMaster", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_GAKKO',
            selectItems: ['GAKCDHONK', 'GAKME'],
            conditions: [],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'GAKCDHONK',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }
        const response = crud(request);
        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const codeList = (await response).data?.resultData.map((item: { GAKCDHONK: string; GAKME: string; }) => {
                return { id: item.GAKCDHONK, value: item.GAKME }
            })
            setCodeList(codeList);
            setLoading(false);
        } else {
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        }
    };

    React.useEffect(() => {
        if (isOpen) {
            setError(false);
            setKeyword('');
            setCheckCode(new Set());
            setSearchHidden(new Set());
            if (codeList.length === 0) {
                getShusshinkoMaster()
            }
        }
        setOpen(isOpen)
    }, [isOpen])

    React.useEffect(() => {
        const items: Item[] = []
        codeList.map((v) => items.push({ id: v.value, value: '' }))
        setItems(items)
    }, [codeList])

    const handleOk = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "shusshinkoHandleOk", navigate)) {
            return
        }
        const checkedItems: DialogItemType[] = [];
        for (const x of codeList) if (checkCode.has(x.id)) checkedItems.push({ id: x.value, value: "" });
        if (checkedItems.length === 0) {
            setError(true);
        } else {
            props.handleOk(checkedItems, "or")
        }
    }

    const toggleShussinko = React.useCallback((id: string) => {
        setCheckCode((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);

    useDelayedEffect(
        () => {
            codeList.forEach((info) => {
                if (info.value.includes(keyword)) {
                    setSearchHidden((prev) => {
                        const next = new Set(prev);
                        next.delete(info.id);
                        return next
                    });
                } else {
                    setSearchHidden((prev) => {
                        const next = new Set(prev);
                        next.add(info.id);
                        return next
                    });
                }
            });
        },
        [keyword],
        750,
    )

    return (
        <>
            <BackdropLoading open={loading} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                sx={{
                    zIndex: 900
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 900
                        }
                    }
                }}
            >
                <Zoom
                    in={open}
                    style={{ zIndex: 1000, transformOrigin: '-50% -50% -50%' }}
                    easing={{
                        enter: "cubic-bezier(0, 1.45, 0.62, 1)",
                        exit: "linear"
                    }}
                >
                    <Box sx={modalStyle} tabIndex={-1}>
                        <ModalLabel>
                            選択条件 - 出身校
                        </ModalLabel>
                        {
                            error ?
                                <Box sx={{ marginTop: '2%', marginBottom: '-2%', color: 'red', fontSize: '1.2rem' }}>   条件を一つ以上選択してください</Box>
                                :
                                <></>
                        }
                        <Box p={4}>
                            <Container disableGutters sx={{ width: '70%', marginTop: '2%', marginBottom: '3%' }}>
                                <Grid container marginBottom={1}>
                                    <TextFieldLabel size={3}>出身校名</TextFieldLabel>
                                    <TextFieldForm size={9}>
                                        <TextField fullWidth variant='outlined' value={keyword} size='small' onChange={(event) => setKeyword(event.target.value)} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderRadius: '0px' } }} />
                                    </TextFieldForm>
                                </Grid>
                            </Container>
                            <ShussinkoCheckBoxContainer infoList={codeList} searchHidden={searchHidden} checkCode={checkCode} toggleShussinko={toggleShussinko} />

                        </Box>
                        <Box p={2} sx={{ marginTop: '-3%', marginBottom: '1%' }}>
                            <Grid container sx={{ width: '98%' }}>
                                <Grid size={7} />
                                <Grid size={5}>
                                    <CancelButton variant="contained" onClick={() => handleClose(false)}>キャンセル</CancelButton>
                                    <OkButton variant="contained" onClick={() => handleOk()}>OK</OkButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Zoom>
            </Modal >
        </>
    );
}

export default ShusshinkoDialog;
